export const MAX_ARCHIVE_PAGES = 20
export const POSTS_PER_PAGE = 9
